// The projects page (GIOTHUB-185).
import type { Dict } from "./dict";

const en = {
  "projects.title": "Projects",
  "projects.none": "No device types yet in your organisation.",
  "projects.scenario": "Scenario {s}",
  "projects.kind.a": "protobuf",
  "projects.kind.b": "new device, protobuf",
  "projects.kind.c": "JavaScript",
  "projects.target.git": "Git repository",
  "projects.target.store": "gIoT Store",
  "projects.new": "New device type",
  "projects.how": "How the device speaks",
  "projects.a.title": "Existing protobuf",
  "projects.a.text": "You upload the .proto; the assistant classifies every field.",
  "projects.c.title": "Vendor protocol",
  "projects.c.text": "You give the payload documentation and examples; the assistant writes the JavaScript decoder.",
  "projects.b.title": "New device",
  "projects.b.text": "You describe the device; the assistant writes the requirements, designs the protocol (protobuf + nanopb) and the type.",
  "projects.name": "Name",
  "projects.typeid": "Type id (reverse domain)",
  "projects.create": "Create project",
} as const;

const de = {
  "projects.title": "Projekte",
  "projects.none": "In Ihrer Organisation gibt es noch keine Gerätetypen.",
  "projects.scenario": "Szenario {s}",
  "projects.kind.a": "Protobuf",
  "projects.kind.b": "neues Gerät, Protobuf",
  "projects.kind.c": "JavaScript",
  "projects.target.git": "Git-Repository",
  "projects.target.store": "gIoT Store",
  "projects.new": "Neuer Gerätetyp",
  "projects.how": "Wie das Gerät kommuniziert",
  "projects.a.title": "Bestehendes Protobuf",
  "projects.a.text": "Sie laden die .proto-Datei hoch; der Assistent klassifiziert jedes Feld.",
  "projects.c.title": "Herstellerprotokoll",
  "projects.c.text": "Sie geben die Payload-Dokumentation und Beispiele; der Assistent schreibt den JavaScript-Decoder.",
  "projects.b.title": "Neues Gerät",
  "projects.b.text": "Sie beschreiben das Gerät; der Assistent schreibt die Anforderungen, entwirft das Protokoll (Protobuf + nanopb) und den Typ.",
  "projects.name": "Name",
  "projects.typeid": "Typ-ID (umgekehrte Domain)",
  "projects.create": "Projekt erstellen",
} satisfies Dict<typeof en>;

const it = {
  "projects.title": "Progetti",
  "projects.none": "Nella sua organizzazione non ci sono ancora tipi di dispositivo.",
  "projects.scenario": "Scenario {s}",
  "projects.kind.a": "protobuf",
  "projects.kind.b": "nuovo dispositivo, protobuf",
  "projects.kind.c": "JavaScript",
  "projects.target.git": "Repository Git",
  "projects.target.store": "gIoT Store",
  "projects.new": "Nuovo tipo di dispositivo",
  "projects.how": "Come comunica il dispositivo",
  "projects.a.title": "Protobuf esistente",
  "projects.a.text": "Carica il file .proto; l'assistente classifica ogni campo.",
  "projects.c.title": "Protocollo del produttore",
  "projects.c.text": "Fornisce la documentazione del payload ed esempi; l'assistente scrive il decoder JavaScript.",
  "projects.b.title": "Nuovo dispositivo",
  "projects.b.text": "Descrive il dispositivo; l'assistente scrive i requisiti, progetta il protocollo (protobuf + nanopb) e il tipo.",
  "projects.name": "Nome",
  "projects.typeid": "ID del tipo (dominio inverso)",
  "projects.create": "Crea progetto",
} satisfies Dict<typeof en>;

const fr = {
  "projects.title": "Projets",
  "projects.none": "Votre organisation n'a pas encore de types d'appareils.",
  "projects.scenario": "Scénario {s}",
  "projects.kind.a": "protobuf",
  "projects.kind.b": "nouvel appareil, protobuf",
  "projects.kind.c": "JavaScript",
  "projects.target.git": "Dépôt Git",
  "projects.target.store": "gIoT Store",
  "projects.new": "Nouveau type d'appareil",
  "projects.how": "Comment l'appareil communique",
  "projects.a.title": "Protobuf existant",
  "projects.a.text": "Vous chargez le fichier .proto ; l'assistant classe chaque champ.",
  "projects.c.title": "Protocole du fabricant",
  "projects.c.text": "Vous fournissez la documentation du payload et des exemples ; l'assistant écrit le décodeur JavaScript.",
  "projects.b.title": "Nouvel appareil",
  "projects.b.text": "Vous décrivez l'appareil ; l'assistant rédige les exigences, conçoit le protocole (protobuf + nanopb) et le type.",
  "projects.name": "Nom",
  "projects.typeid": "ID du type (domaine inversé)",
  "projects.create": "Créer le projet",
} satisfies Dict<typeof en>;

export default { en, de, it, fr };
